import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { TileScope } from '@api/models/dashboard/TileScope';

interface Props {
  value: TileScope;
  onChange: (scope: TileScope) => void;
}

export const ScopeSelector: FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();
  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      onChange={(_, next: TileScope | null) => {
        if (next) onChange(next);
      }}
      sx={{ textTransform: 'none' }}
    >
      <ToggleButton value="company" sx={{ textTransform: 'none' }}>
        {t('analytics.scope.company')}
      </ToggleButton>
      <ToggleButton value="global" sx={{ textTransform: 'none' }}>
        {t('analytics.scope.global')}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
